<template>
  <div>
    <loading
      name="lp"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <div class="row" style="text-align: right">
      <div class="col-lg-4" style="text-align: left">
        <base-button type="info" @click.prevent="onRefresh" icon>
          <span class="btn-inner--icon">
            <i class="ni refresh-02"></i> </span
          >Refresh
        </base-button>
      </div>
      <div class="col-lg-4"></div>
      <div class="col-lg-4">
        <base-input
          v-model="search.text"
          prepend-icon="fas fa-search"
          placeholder="Search..."
        ></base-input>
      </div>
    </div>
    <el-table
      :data="
        tableData.filter(
          (data) =>
            !search.text ||
            data.title.toLowerCase().includes(search.text.toLowerCase()) ||
            data.stagetitle.toLowerCase().includes(search.text.toLowerCase()) ||
            (data.teachername !== null &&
              data.teachername
                .toLowerCase()
                .includes(search.text.toLowerCase()))
        )
      "
      header-row-class-name="thead-light"
    >
      <el-table-column label="Lesson" prop="name" sortable>
        <template v-slot="{ row }">
          <div class="row">
            <div class="col-lg-12">
              <h4>
                Status: {{ row.statusname }}
                <i v-if="row.status === 1" class="text-danger ni t-warning"></i>
                <i v-if="row.status === 2" class="text-orange ni megaphone"></i>
                <i v-if="row.status === 3" class="text-blue ni hourglass"></i>
                <i v-if="row.status === 4" class="text-info ni laptop"></i>
                <i v-if="row.status === 5" class="text-green ni verified"></i>
              </h4>
            </div>
            <div class="col-lg-4">Stage</div>
            <div class="col-lg-8">{{ row.stagetitle }}</div>
            <div class="col-lg-4">Lesson</div>
            <div class="col-lg-8">{{ row.title }}</div>
            <div class="col-lg-4">Teacher</div>
            <div class="col-lg-8">
              <b
                >{{ row.teachername }} ({{
                  row.locationtype
                    ? row.locationtype === 1
                      ? row.locationtypename
                      : row.locationtypename + ": " + row.location
                    : "N/A"
                }})</b
              >
            </div>
            <div class="col-lg-4">Lesson date</div>
            <div class="col-lg-8">
              <b>{{ row.lessondatestr }}</b>
            </div>
            <div class="col-lg-4">Duration</div>
            <div class="col-lg-8">{{ row.duration }} min</div>
            <div class="col-lg-4">Notes</div>
            <div class="col-lg-8">{{ row.notes }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="right" label="Actions" width="200px">
        <div slot-scope="{ $index, row }" class="d-flex">
          <el-tooltip
            class="item"
            effect="dark"
            content="View lesson"
            placement="top"
          >
            <base-button
              @click.native="onOpen($index, row)"
              class="edit"
              type="default"
              size="sm"
              :disabled="row.status <= 2"
              icon
            >
              <i class="text-white ni preview"></i>
            </base-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="Schedule"
            placement="top"
          >
            <base-button
              @click.native="onEdit($index, row)"
              class="edit"
              type="warning"
              size="sm"
              :disabled="row.status >= 4"
              icon
            >
              <i class="text-white ni n-edit"></i>
            </base-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="Publish"
            placement="top"
          >
            <base-button
              @click.native="onPublish($index, row)"
              class="edit"
              type="info"
              size="sm"
              :disabled="!(row.status <= 3)"
              icon
            >
              <i class="text-white ni ic_publish_24px"></i>
            </base-button>
          </el-tooltip>
        </div>
      </el-table-column>
    </el-table>

    <modal :show.sync="modalform" size="lg">
      <h6 slot="header" class="modal-title">Lesson action</h6>
      <validation-observer ref="formvalid">
        <div class="row">
          <div class="col-lg-6">
            <base-input label="Teacher" rules="required" name="teacher">
              <el-select
                class="select-primary pagination-select"
                v-model="lesson.teacherid"
                placeholder="Teacher"
              >
                <el-option
                  class="select-primary"
                  v-for="item in users"
                  :key="item.id"
                  :label="item.fullname"
                  :value="item.id"
                ></el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input label="Lesson date" rules="required" name="Lesson date">
              <flat-picker
                :config="{
                  allowInput: true,
                  enableTime: true,
                  minDate: classStartDate,
                  time_24hr: true,
                  dateFormat: 'Y-m-d H:i',
                }"
                class="form-control datepicker"
                v-model="lesson.lessondate"
              ></flat-picker>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <base-input label="Location">
              <el-select
                class="select-primary pagination-select"
                v-model="lesson.locationtype"
                placeholder="Location"
              >
                <el-option
                  class="select-primary"
                  label="Online"
                  :value="1"
                ></el-option>
                <el-option
                  class="select-primary"
                  label="Room"
                  :value="2"
                ></el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input
              name="location"
              v-model="lesson.location"
              class="mb-3"
              :label="lesson.locationtype === 2 ? 'Room' : 'Meeting link'"
              :placeholder="lesson.locationtype === 2 ? 'Room' : 'Meeting link'"
            ></base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <base-input label="Notes" class="mr-1">
              <textarea
                class="form-control"
                rows="3"
                resize="none"
                v-model="lesson.notes"
              ></textarea>
            </base-input>
          </div>
        </div>
      </validation-observer>
      <div class="text-center">
        <base-button type="primary" @click.native="onSave"
          >Save changes</base-button
        >
      </div>
    </modal>
  </div>
</template>

<script>
import swal from "sweetalert2";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import {
  Table,
  TableColumn,
  Select,
  Option,
  Tooltip,
  Button,
} from "element-ui";
import { Modal, BaseAlert } from "@/components";
import { StudentType } from "../../../services/types";
import {
  GetLessons,
  UpdateLesson,
  PublishLesson,
} from "../../../services/classes";
import { SearchStudents } from "../../../services/user";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { nophoto, fileUrl } from "../../../services/helper";
import { GetTeachers } from "../../../services/user";
export default {
  name: "students",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
    Modal,
    HtmlEditor,
    Loading,
    flatPicker,
  },
  props: {
    classId: String,
    classStartDate: String,
  },
  computed: {
    fileurl() {
      return fileUrl;
    },
  },
  data() {
    return {
      tableData: [],
      isLoading: false,
      modalform: false,
      lesson: {},
      lessons: [],
      loading: false,
      search: { text: "" },
      users: [],
    };
  },
  methods: {
    onRefresh() {
      this.loadLessons();
    },
    loadLessons() {
      if (!this.classId) {
        this.tableData = [];
        return;
      }
      this.isLoading = true;
      GetLessons(this.classId).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.tableData = response.data.result;
        } else {
          this.tableData = [];
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
    onEdit(index, row) {
      this.lesson = Object.assign({}, row);
      this.lesson.locationtype = this.lesson.locationtype
        ? this.lesson.locationtype
        : 1;
      this.lesson.classid = this.classId;
      this.modalform = true;
    },
    onSave() {
      this.$refs.formvalid.validate().then((valid) => {
        if (valid) {
          this.isLoading = true;
          UpdateLesson(this.lesson).then((response) => {
            this.isLoading = false;
            if (response.data.result) {
              this.modalform = false;
              this.loadLessons();
            } else {
              this.notifyVue("danger", response.data);
            }
          });
        }
      });
    },
    onPublish(index, row) {
      swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this! All students of the class will receive email regarding Lesson date.`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, publish it!",
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;
            PublishLesson(row.id).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.loadLessons();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          }
        });
    },
    onOpen(index, row) {
      let routeData = this.$router.resolve({
        name: "Lesson",
        params: { id: row.id, classId: this.classId },
      });
      window.open(routeData.href, "_blank");
    },
  },
  mounted() {
    this.loadLessons();

    GetTeachers().then((response) => {
      if (response.data !== null) {
        this.users = response.data.result;
      }
    });
  },
  watch: {
    classId: function () {
      this.loadLessons();
    },
  },
};
</script>
<style scoped>
.item {
  margin: 4px;
}
</style>
